import IframeActivity from "./IframeActivity";

export default function FocusLab() {
    return (
        <IframeActivity
            src="/activities/focus-lab/index.html"
            title="Focus Lab"
        />
    );
}